<template>
  <!-- Covers the page, prevents the user from seeing flashing page transition -->
  <span class="appCover"></span>

  <!-- Shared folder View -->
  <VApp v-if="sharedFolderRoute">
    <VMain>
      <div class="pa-2 page-container">
        <router-view />

        <Snackbar />
      </div>
    </VMain>
  </VApp>

  <!-- Rest of the app -->
  <ApplicationWrapper
    v-else
    :routes="routes"
    :hidePageHeader="false"
    :publicRoutes="fileManagerPublicRoutes"
    loginRedirectionRoute="/"
  >
    <router-view />

    <Snackbar />
  </ApplicationWrapper>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { computed, onBeforeMount, ref } from 'vue';
// import { isString } from '@metools/tcheck';

import { ApplicationWrapper } from '@qsrsoft/myq-core';
import { routes, fileManagerPublicRoutes } from '@/routes';
import Snackbar from '@/components/snackbar.vue';

const router = useRouter();

const isReady = ref(false);

// const sharedFolderPath = '/fileManager/sharedFolder';

const sharedFolderRoute = computed(() => {
  //Turning this off for now.
  return false;

  // Uncomment this when the shared folder feature is ready
  // if (route.path === sharedFolderPath) {
  //   const { sharedFolderId, orgId } = route.query;
  //   if (isString(sharedFolderId) && isString(orgId)) {
  //     return true;
  //   }
  // }

  // return false;
});

const coverOpacity = computed(() => {
  const val = isReady.value ? 0 : 1;
  return val;
});

/**
 * Sets the isReady value to true when the router is ready. This is used
 * to get the initial route (rather than '/'). The app uses this value
 * to cover the page and only reveal the contents when the router has
 * been initialied
 */
async function setIsReady() {
  try {
    console.log('getting router ready');
    await router.isReady();
    console.log('router is ready');
    isReady.value = true;
  } catch (e) {
    isReady.value = true;
    console.error(`isReady error ${e}`);
  }
}

onBeforeMount(() => {
  setIsReady();
});
</script>

<style scoped>
.page-container {
  background: rgb(var(--v-theme-surface-page));
  height: 100%;
}

.appCover {
  pointer-events: none;
  background-color: rgb(var(--v-theme-surface-page));
  opacity: v-bind(coverOpacity);
  transition: opacity 0.15s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}
</style>
